export default "__VITE_ASSET__CKAQp02i__"